import { Icon24PerspectiveFunctionLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const DepthIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <g clipPath="url(#clip0_1985_509)">
        <path
          d="M20.1818 3H3.81818C3.36631 3 3 3.36631 3 3.81818V20.1818C3 20.6337 3.36631 21 3.81818 21H20.1818C20.6337 21 21 20.6337 21 20.1818V3.81818C21 3.36631 20.6337 3 20.1818 3Z"
          stroke="currentColor"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 9H9V15H15V9Z"
          stroke="currentColor"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18 6H6V18H18V6Z"
          stroke="currentColor"
          strokeWidth="1.13"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1985_509">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DepthIcon = fplIcon(DepthIconLocal, Icon24PerspectiveFunctionLarge);
